import { createItemsData } from '../utils/request-utils'
import { Service } from './base-service'
import { HALApiService } from './hal-api.service'

export const deliveryServicesService = new Service('/delivery-services', HALApiService, createItemsData)
